'use client';
import { FaXTwitter, FaSquareFacebook, FaLinkedin, FaLink } from 'react-icons/fa6';
import { SiHatenabookmark } from 'react-icons/si';
import { cn } from '@/lib/utils';

export const ShareLinks: React.FC<{
  url: string;
  title: string;
  className?: string;
}> = ({ url, title, className }) => {
  const encodedUrl = encodeURIComponent(url);
  const encodedTitle = encodeURIComponent(title);

  return (
    <aside
      className={cn([
        'w-full flex flex-col lg:flex-row items-center justify-center lg:justify-end gap-x-4 gap-y-3 rounded-sm bg-stone-100 dark:bg-stone-900 mt-4 py-4',
        className,
      ])}
    >
      <span className="text-2xl font-medium cursor-default">Share</span>
      <div className="flex flex-row flex-wrap gap-3">
        <a
          href={`https://twitter.com/intent/tweet?url=${encodedUrl}&text=${encodedTitle}`}
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Share on X (Twitter)"
          title="Share on X (Twitter)"
          className="p-2 bg-black text-white rounded hover:bg-black transition-colors"
        >
          <FaXTwitter size={20} />
        </a>
        <a
          href={`https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`}
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Share on Facebook"
          title="Share on Facebook"
          className="p-2 bg-blue-700 text-white rounded hover:bg-blue-800 transition-colors"
        >
          <FaSquareFacebook size={20} />
        </a>
        <a
          href={`https://www.linkedin.com/shareArticle?mini=true&url=${encodedUrl}&title=${encodedTitle}`}
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Share on LinkedIn"
          title="Share on LinkedIn"
          className="p-2 bg-blue-600 text-white rounded hover:bg-blue-700 transition-colors"
        >
          <FaLinkedin size={20} />
        </a>
        <a
          href={`https://b.hatena.ne.jp/add?mode=confirm&url=${encodedUrl}&title=${encodedTitle}`}
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Share on Hatena Bookmark"
          title="Share on Hatena Bookmark"
          className="p-2 bg-orange-400 text-white rounded hover:bg-orange-500 transition-colors"
        >
          <SiHatenabookmark size={20} />
        </a>
        <button
          type="button"
          title="Copy link to clipboard"
          onClick={() => {
            navigator.clipboard.writeText(url);
            alert('Link copied to clipboard!');
          }}
          aria-label="Copy link to clipboard"
          className="p-2 bg-gray-500 text-white rounded hover:bg-gray-600 transition-colors"
        >
          <FaLink size={20} />
        </button>
      </div>
    </aside>
  );
};
